"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var charts_embed_dom_1 = __importDefault(require("@mongodb-js/charts-embed-dom"));
var react_redux_1 = require("react-redux");
var EmbeddedChart = function (_a) {
    var filter = _a.filter, chartId = _a.chartId, height = _a.height;
    var client = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).client;
    console.log("process.env.MONGO_CHARTS_URL", process.env.MONGO_CHARTS_URL);
    var sdk = new charts_embed_dom_1.default({ baseUrl: process.env.MONGO_CHARTS_URL });
    var chartDiv = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(false), rendered = _b[0], setRendered = _b[1];
    var chart = (0, react_1.useState)(sdk.createChart({
        chartId: chartId,
        height: height,
        filter: filter,
        theme: "light",
        showAttribution: false,
    }))[0];
    (0, react_1.useEffect)(function () {
        chart
            .render(chartDiv.current)
            .then(function () { return setRendered(true); })
            .catch(function (err) { return console.log("Error during Charts rendering.", err); });
    }, [chart]);
    (0, react_1.useEffect)(function () {
        if (rendered) {
            chart.setFilter(filter).catch(function (err) { return console.log("Error while filtering.", err); });
        }
    }, [chart, filter, rendered]);
    return (0, jsx_runtime_1.jsx)("div", { className: "chart bg-white rounded-lg p-2", ref: chartDiv });
};
exports.default = EmbeddedChart;
